


















import {Component, Vue, Prop} from 'vue-property-decorator'
import Modal from '@/components/common/Modal.vue'

@Component({
    components: {
        Modal,
    },
})

export default class DoubleConfirmationModal extends Vue {
  @Prop({type: String, default: 'button-primary'}) public confirmClass!: string
}
